import "@shopify/app-bridge-react";

type ErrorResponse = {
  message: string;
  details?: string | {
    errors: {
      message: string;
      field: string;
    }[]
  }
}

function handleErrorResponse(error: ErrorResponse) {
  let errorMessage = error.message ?? 'An error occurred while sending the email';
  if (error?.details) {
    if (typeof error.details === 'string') {
      errorMessage += ': ' +  error.details;
    }
    else if (error.details.errors && error.details.errors.length > 0){
      errorMessage += ':' + error.details.errors
          .map((e, i) => ` ${i+1}. ` + e.message)
          .join('');
    }
  }
  shopify.toast.show(errorMessage, {
    isError: true,
  })
  throw new Error(errorMessage);
}

function useSendEmail() {
  return async (to: string[], subject: string, content: string, cc: string[] = [], bcc: string[] = []) => {
    if (!to) throw 'Emails to send to not provided';
    if (!subject) throw 'Subject not provided';
    if (!content) throw 'Content not provided';

    console.info('Sending email', to, subject, content, cc, bcc);

    return await fetch("/api/email", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        to,
        subject,
        content: content,
        cc: cc || [],
        bcc: bcc || [],
      })
    }).then(async res => {
      const json = await res.json();
      if (!res.ok) {
        handleErrorResponse(json);
      }
      return json;
    });
  };
}

export default useSendEmail;
